/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, Carousel } from "antd";
import styled from "styled-components";
import { CaretRightOutlined, CaretLeftOutlined } from "@ant-design/icons";
import { ReviewTitleText } from "./ContactStyle";
import ReviewCard from "./ReviewCard";

const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ArrowButton = styled(Button)`
  background-color: #fdd440;
  &:focus {
    background-color: #fdd440;
  }
`;

const ReviewCarousel = styled(Carousel)`
  .slick-slide {
    padding: 0 5px;
  }
  /* the parent */
  .slick-list {
    padding: 0 -5px;
  }
`;

const Reviews = () => {
  const { t } = useTranslation("registration");
  const reviews = useReviews();
  const isMobile = (): boolean =>
    !window.matchMedia("(min-width: 500px)").matches;

  const slider: React.RefObject<any> = useRef(null);

  return (
    <div>
      <ReviewHeader>
        <ReviewTitleText>{t("What Our Students Think")}</ReviewTitleText>
        <div>
          <ArrowButton
            type="primary"
            shape="circle"
            icon={<CaretLeftOutlined />}
            onClick={() => slider.current.prev()}
          />
          <ArrowButton
            style={{ marginLeft: "10px" }}
            type="primary"
            shape="circle"
            icon={<CaretRightOutlined />}
            onClick={() => slider.current.next()}
          />
        </div>
      </ReviewHeader>
      <ReviewCarousel
        style={{
          width: isMobile() ? `${window.innerWidth - 40}px` : "525px",
        }}
        dots={false}
        arrows
        ref={slider}
      >
        {reviews.map((review) => (
          <div>
            <ReviewCard
              testimonial={review[0].testimonial}
              customer={review[0].customer}
            />
            <ReviewCard
              style={{ marginTop: "10px" }}
              testimonial={review[1].testimonial}
              customer={review[1].customer}
            />
          </div>
        ))}
      </ReviewCarousel>
    </div>
  );
};

export default Reviews;

function useReviews() {
  const { t } = useTranslation("registration");

  return [
    [
      {
        testimonial: t(
          "Kisha is an excellent teacher. At this point, I've had 10+ classes with her and every single one has been fantastic."
        ),
        customer: t("Bruce, Australia"),
      },
      {
        testimonial: t(
          "Really happy with how Jason presents the learning materials."
        ),
        customer: t("Marco, Italy"),
      },
    ],
    [
      {
        testimonial: t(
          "Emma made sure that my pronunciation was just right and she was very patient with me."
        ),
        customer: t("Ann, UK"),
      },
      {
        testimonial: t(
          "Really enjoyed lesson with Rachel, she is a great teacher :)"
        ),
        customer: t("Antonio, Italy"),
      },
    ],
    [
      {
        testimonial: t(
          "Fantastic. The teacher explained the new grammar points and we practiced them long enough so that I wouldn't forget."
        ),
        customer: t("Iris, Switzerland"),
      },
      {
        testimonial: t(
          "Enjoyed the class, Lydia is flexible with approach and takes time to have free talk which I appreciate. 10/10"
        ),
        customer: t("Sarti, Egypt"),
      },
    ],
    [
      {
        testimonial: t(
          "Mandy has a lovely personality, is very patient and really encouraged me to speak."
        ),
        customer: t("Maria, Russia"),
      },
      {
        testimonial: t(
          "Evelyn is really attentive, she really takes her time to explain if I have any questions. Wonderful class!"
        ),
        customer: t("David, USA"),
      },
    ],
    [
      {
        testimonial: t("Tina is AMAZING!!"),
        customer: t("Iris, Germany"),
      },
      {
        testimonial: t(
          "This was a great class with a lot of opportunity to stretch myself rather than just repeat the material we were revising. Thanks Cassy!"
        ),
        customer: t("Robert, Hong Kong"),
      },
    ],
    [
      {
        testimonial: t(
          "Rachel has an incredible patience. She was amazing in this class, making both of us got something out of it."
        ),
        customer: t("Rob, France"),
      },
      {
        testimonial: t(
          "Excellent pacing and command of the class. Very enjoyable."
        ),
        customer: t("Muhammad, USA"),
      },
    ],
  ];
}
